import React,{ useEffect, useState, } from 'react';
import { useSelector,useDispatch } from 'react-redux';
import { formatNumber, CTicksToDateStringRemainTime, formatTotalTime } from '../Utility.js';
import { useNavigate } from 'react-router-dom';

function Title()
{
    const state=useSelector((state)=>state);
    const dispatch = useDispatch();
    const navigate = useNavigate();


    useEffect(() => {
        var intervalId = -1;
        intervalId = setInterval(() => 
        {
            const milliseconds =  1 * 1000 * 60;
            
            dispatch({type:'MinusUpdateRemainTime', DeltaMilliSecond:10000000});
        }, 1000);
        return () =>{ clearInterval(intervalId);};
      }, []);

      //function StartRemainTime() {
      //  if(state.RaminTime === undefined || state.RaminTime === 0)
      //  {
      //      return;
      //  }
      //  console.log("1초마다 실행되는 함수 호출");

      //  const milliseconds =  1 * 1000;
      //  dispatch({type:'UpdateRemainTime', RemainTime:(state.RaminTime - milliseconds)});
    //}

    //if(intervalId === -1)
    //{
    //    intervalId = setInterval(StartRemainTime(state.RemainTime), 1000);
    //}

    function LogOutClick()
    {
        if(window.confirm("로그아웃 하시겠습니까?")) {
            navigate('/login'); // 로그인 성공 시 메인 페이지로 이동            
        }
    }

    const openRechargePointModal = () => {
        dispatch({type:'UpdateRechargePointModal', View:true});
    }

    const openTimeTicketBuyModal = () => {
        dispatch({type:'UpdateTimeTicketBuyModal', View:true});
    }

    const openTimeTicketUseModal = () => {
        dispatch({type:'UpdateTimeTicketUseModal', View:true});
    }

    const openServiceCenterModal = () => {
        dispatch({type:'UpdateServiceCenterModal', View:true});
    }

    const openServiceGuideModal = () => {
        window.open("https://youtube.com/@seongkwonkim-r9u?si=oG5PyV8jpRHEAwZ3", "_blank");
        //alert("준비 중 입니다.");
    }

    return (        
    <div className='title-box'>
      <div className="top-menu">
        <div className="logo-box">
            <img src="./img/fit.png"/>
        </div>
        <div className='user-info-box'>
            <span className="user-nickname"><h2>닉네임</h2> <p>{state.NickName}</p></span>
            <span className="user-point"><h2>포인트</h2><p>{formatNumber(state.Point)}{"P"}</p></span>
            <span className={`remain-time ${state.RemainTime <= 300000 * 10000 && state.RemainTime > 0 ? "warning" : ""}`}>
                <h2>남은 시간</h2>
                <p>{CTicksToDateStringRemainTime(state.RemainTime)}</p>
            </span>
        </div>
       </div>
        <div className='button-box'>
          <div className="menu-scroll">
            <div className="point-recharge" onClick={openRechargePointModal}><h2>포인트 충전</h2></div>
            <div className="service-guide" onClick={openServiceGuideModal}><h2>도움말</h2></div>
            <div className="buy-time" onClick={openTimeTicketBuyModal}><h2>시간권 구매</h2></div>
            <div className="use-time" onClick={openTimeTicketUseModal}><h2>시간권 사용</h2></div>
            <div className="service-center" onClick={openServiceCenterModal}><h2>고객센터</h2></div>
            <div className="logout" onClick={LogOutClick}><h2>로그아웃</h2></div>
           </div>
        </div>
    </div>
    );
}

export default Title